import React from 'react'
import Helmet from 'react-helmet'
import data from '../../data/index'

// import { FullPage, Slide } from 'react-full-page'
// import SlideshowControls from '../../components/SlideshowControls'
import SlideshowFooter from '../../components/SlideshowFooter'

class LandingPage extends React.Component {

    render() {

        let id = 10;
        let name = 'Fenton'
        let prev = '/brand-design/literacy-for-all';
        let next = '/brand-design/birth';

        // Dynamically generate slideshow
        // let sliderImages = data[id].slideshow.map((img, idx) => {
        //     return(
        //         <Slide key={`image-${idx}`} className='slide-container' style={{backgroundImage: `url(${img})`}} />
        //     )
        // });

        let sliderImages = data[id].slideshow.map((img, idx) => {
            return(
                <img key={`image-${idx}`} src={img} />
            )
        });

        return (
            <div id='brand-landing'>
                <Helmet>
                    <title>IMBIBE - Brand Design: {name}</title>
                    <meta name="description" content={`Brand Design: ${name}`} />
                </Helmet>

                {/*<FullPage ref="slideShow" controls={SlideshowControls}>*/}
                    {sliderImages}
                {/*</FullPage>*/}

                <SlideshowFooter branding prev={prev} next={next} />
            </div>
        )
    }
}

export default LandingPage


// WEBPACK FOOTER //
// ./src/pages/brand-design/fenton.js